
<ng-container *ngIf="{ installers: installers$ | async } as resolved">
  <ng-container *ngIf="resolved.installers && resolved.installers.length > 0">
    <div class="fx-col my-3 px-3 d-block">
      <img
        src="blocks-assets/images/certified-operators.svg"
        class="s-20 mt-3 mx-auto">
      <ng-container *ngIf="myEmail$ | async as email">
        <ion-label class="text-grey-500 text-center text-bold body-1">
          {{ email }}
        </ion-label>
      </ng-container>
      <div class="radius-4 my-6 px-3 bg-coolgrey min-h-32 fx-align-content-center fx-center fx-col">
        <p class="text-grey-500 text-left text-400">
          {{ labels.certificationDescription }}
        </p>
      </div>

      <div class="fx-row fx-wrap fx-gap-1">
        <div
          *ngIf="(is_servicePartner$ | async)"
          class="bg-accent-100 radius-4 px-3 tw-font-medium tw-text-sm fx-center py-1 border-1 border-accent-200 text-grey-400">
          {{ labels.servicePartner }}
        </div>
        <div
          *ngIf="(is_baseCertificationInstaller$ | async)"
          class="bg-accent-100 radius-4 px-3 tw-font-medium tw-text-sm fx-center py-1 border-1 border-accent-200 text-grey-400">
          {{ labels.baseCertificationInstaller }}
        </div>
        <div
          *ngIf="(is_advancedCertificationInstaller$ | async)"
          class="bg-accent-100 radius-4 px-3 tw-font-medium tw-text-sm fx-cente py-1 border-1 border-accent-200 text-grey-400">
          {{ labels.advancedCertificationInstaller }}r
        </div>
      </div>

      <!-- If is mobile-->
      <ng-container *ngIf="mode === 'mobile'">
        <ion-list>
          <ion-item
            *ngFor="let item of resolved.installers"
            lines="none">
            <ion-label class="text-grey-500">
              <span class="text-grey-400 text-bold">Cod Installatore: </span>{{ item?.codInstallatore }}
            </ion-label>
            <ion-button
              fill="clear"
              size="small"
              class="no-padding"
              [disabled]="!item.codInstallatore || !item.emailCert"
              (click)="item.codInstallatore && item.emailCert && deleteRegistration(item.codInstallatore, item.emailCert)">
              <ion-icon
                class="s-5 text-red-400"
                name="trash"
                slot="icon-only">
              </ion-icon>
            </ion-button>
          </ion-item>
        </ion-list>
      </ng-container>

      <!-- If is browser -->
      <ng-container *ngIf="mode === 'browser'">
        <mat-list>
          <mat-list-item *ngFor="let item of resolved.installers">
            <ng-container *ngIf="item?.codInstallatore">
              <div class="fx-row w-full fx-justify-between fx-align-center">
                <span class="text-grey-500">
                  <strong>Cod Installatore: </strong>{{ item.codInstallatore }}
                </span>
                <button
                  mat-icon-button
                  [disabled]="!item.codInstallatore || !item.emailCert"
                  (click)="item.codInstallatore && item.emailCert && deleteRegistration(item.codInstallatore, item.emailCert)">
                  <mat-icon class="text-red-400">delete</mat-icon>
                </button>
              </div>
            </ng-container>
          </mat-list-item>
        </mat-list>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

